import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'pluraliseUnit',
})
export class PluraliseUnitPipe implements PipeTransform {
  transform(unit: string, value: number): any {
    if (value !== 1) {
      unit = unit + 's';
    }

    return ` ${unit}`;
  }
}
